export default {"src":"/_next/static/image/assets/Illustrations/newsletter bw 1.6510b31650b2cd3169225cefbc0b89ac.svg","height":400,"width":534};